import { defineComponent } from "vue";
export default defineComponent({
  name: "infiniteScroll",
  setup: function setup(props, _ref) {
    var emit = _ref.emit;

    var load = function load() {
      emit("scrollLoad");
    };

    return {
      load: load
    };
  },
  components: {}
});